/** Active `/` token at cursor (after start or whitespace). */
export function getSlashContext(
  value: string,
  cursorPos: number = value.length
): { slashIndex: number; query: string } | null {
  const before = value.slice(0, cursorPos);
  const match = before.match(/(?:^|\s)\/([^\s]*)$/);
  if (!match) return null;
  const slashIndex = before.lastIndexOf('/');
  return { slashIndex, query: match[1] ?? '' };
}

export function insertSlashCommand(
  text: string,
  cursorPos: number,
  template: string
): { value: string; cursorPos: number } {
  const ctx = getSlashContext(text, cursorPos);
  if (!ctx) {
    return { value: template, cursorPos: template.length };
  }
  const value = text.slice(0, ctx.slashIndex) + template + text.slice(cursorPos);
  return { value, cursorPos: ctx.slashIndex + template.length };
}
